module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "slider"
  }, [_c('ul', {
    staticClass: "slides"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/048.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption center-align"
  }, [_c('h3', [_vm._v("O Melhor Hotel da Região!")]), _vm._v(" "), _c('h5', {
    staticClass: "light grey-text text-lighten-3"
  }, [_vm._v("Venha conferir!")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/060.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption left-align"
  }, [_c('h3', [_vm._v("Os Melhores Serviços")]), _vm._v(" "), _c('h5', {
    staticClass: "light grey-text text-lighten-3"
  }, [_vm._v("Você só encontra aqui!")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/072.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption right-align"
  }, [_c('h3', [_vm._v("Acomodações")]), _vm._v(" "), _c('h5', {
    staticClass: "light grey-text text-lighten-3"
  }, [_vm._v("Suítes de Luxo!")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "col s6 m3 l3"
  }, [_c('div', {
    staticClass: "card z-depth-2 center blue-grey darken-1 hoverable"
  }, [_c('div', {
    staticClass: "card-content white-text flow-text"
  }, [_c('p', {
    staticClass: "flow-text"
  }, [_vm._v("Sua Melhor Opção em Resplendor!")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 m3 l3"
  }, [_c('div', {
    staticClass: "card z-depth-2 center hoverable"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('a', {
    attrs: {
      "href": "#!"
    }
  }, [_c('img', {
    attrs: {
      "height": "100",
      "src": require("../../img/galeriaFotos/081.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-content brown-text"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("Executivas")]), _vm._v(" "), _c('a', {
    staticClass: "brown-text",
    attrs: {
      "href": "#!"
    }
  }, [_vm._v("Suíte executiva / Noite de núpcias...")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 m3 l3"
  }, [_c('div', {
    staticClass: "card z-depth-2 center hoverable"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('a', {
    attrs: {
      "href": "#/hotel/localizacao"
    }
  }, [_c('img', {
    attrs: {
      "height": "100",
      "src": require("../../img/mapa-resplendor.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-content brown-text"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("Localização")]), _vm._v(" "), _c('a', {
    staticClass: "brown-text",
    attrs: {
      "href": "#/hotel/localizacao"
    }
  }, [_vm._v("Av. Olegário Maciel N.364 B -Centro, Resplendor MG")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 m3 l3"
  }, [_c('div', {
    staticClass: "card z-depth-2 center hoverable"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('a', {
    attrs: {
      "href": "#!"
    }
  }, [_c('img', {
    attrs: {
      "height": "100",
      "src": require("../../img/galeriaFotos/008.jpg")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-content brown-text"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("Serviços")]), _vm._v(" "), _c('a', {
    staticClass: "brown-text",
    attrs: {
      "href": "#/servicos"
    }
  }, [_vm._v("Café da manhã, Sala de Reunião ...")])])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c17b589", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c17b589"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/home.vue
// module id = 80
// module chunks = 0